import { Moment } from "moment-timezone";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";
import moment from "moment";
import ApiDateParser from "../../helpers/parsers/apiDateParser";

export default class CalendarScheduleCandidate {
  start_time: string;
  end_time: string;
  day_of_the_week: string;
  schedule_slot_id?: number;
  date?: Moment;

  constructor(arg: CalendarScheduleSlotModel) {
    this.start_time = ApiDateParser.toNormalizedApiDate(moment(arg.startTime));
    this.end_time = ApiDateParser.toNormalizedApiDate(moment(arg.endTime));
    this.day_of_the_week = arg.dayOfWeekName;
    this.schedule_slot_id = arg?.id;
    this.date = arg.date;
  }
}
